<div mat-dialog-title class="app-dialog-title" i18n="@@login-phone-popup-title|Login phone popup title">
	Conectarme a mi cuenta
	<button mat-icon-button class="close-button" (click)="close()">
		<mat-icon>cancel</mat-icon>
	</button>
</div>
<mat-dialog-content class="dialog-content">
	<p class="app-dialog-content-title" i18n="@@login-phone-popup-prompt|Login phone prompt">
		Para continuar ingresa tu teléfono.
	</p>
	@if (!phoneConfirmationResult()) {
		<form [formGroup]="form" (ngSubmit)="sendOtp()">
			<div class="form-content">
				<mat-form-field floatLabel="auto">
					<mat-label i18n="@@login-phone-popup-country-code-label|Country code label">Código del país</mat-label>
					<mat-select formControlName="phoneCountryCode" i18n-matTooltip="@@login-phone-popup-country-code-tooltip|Country code tooltip" matTooltip="Código del país" [required]="true">
						<mat-option value="+57">+57</mat-option>
						<mat-option value="+1">+1</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field floatLabel="auto" class="phone-number-form-field">
					<mat-label i18n="@@login-phone-popup-phone-label|Phone field label">Teléfono</mat-label>
					<input matInput i18n-placeholder="@@login-phone-popup-phone-placeholder|Phone field placeholder" type="tel" placeholder="Teléfono" name="phone" formControlName="phone" appInputEmptyToNull required autocomplete="tel-national">
				</mat-form-field>
				<div>
					<app-form-message [serverError]="serverError()" [serverResponse]="serverResponse()"></app-form-message>
					<div id="login-phone-recaptcha-container"></div>
					<span i18n="@@login-phone-popup-sms-notice|SMS confirmation notice">Se enviará un código de confirmación por SMS, se aplicarán cargos estándar.</span>
				</div>
				<button type="submit" mat-raised-button [disabled]="recaptchaVerifier || !submitButtonActive()" class="submit-button app-primary-background" i18n="@@login-phone-popup-send-code|Send code button label">Enviar código</button>
			</div>
		</form>
	} @else {
		<p i18n="@@login-phone-popup-code-sent|Code sent to phone number message">Ingresa el código enviado al número {{form.controls.phoneCountryCode.value}} {{form.controls.phone.value}}</p>
		<mat-form-field>
			<mat-label i18n="@@login-phone-popup-code-label|Code field label">Código</mat-label>
			<input #PhoneVerificationCodeInput matInput type="tel" name="PhoneVerificationCode" [disabled]="!submitButtonActive()" autocomplete="one-time-code">
		</mat-form-field>
		<button mat-raised-button class="submit-button app-primary-background" (click)="login(PhoneVerificationCodeInput.value)" i18n="@@login-phone-popup-login-submit|Login button label">Log in</button>
	}
	<mat-divider></mat-divider>
	<a href="{{environment.apiServer.url}}/api/authentication/login-google">
		<button mat-fab extended [disabled]="!submitButtonActive()" class="submit-button app-surface-container app-elevation0 login-phone-button" i18n="@@login-phone-popup-google-login|Login with Google button label">
			<mat-icon>
				<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
					<path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
					<path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
					<path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
					<path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
				</svg>
			</mat-icon>
			Iniciar sesión con Google
		</button>
	</a>
	<mat-divider></mat-divider>
	<span i18n="@@login-phone-popup-new-customer|New customer prompt with signup link">Nuevo cliente? <a [routerLink]="['/signup']" (click)="close(true)">Crear cuenta</a></span>
	<span i18n="@@login-phone-popup-has-account|Existing account prompt with login link">Ya tienes una cuenta? <a [routerLink]="['/login']" (click)="close(true)">Entra aquí</a></span>
	<span i18n="@@login-phone-popup-forgot-password|Forgot password prompt with recovery link">Contraseña olvidada? <a [routerLink]="['/forgot-password']" (click)="close(true)">Recuperar contraseña</a></span>
	<span class="legal-consent" i18n="@@auth-legal-consent|Consent notice shown under the sign-in options">Al continuar aceptas nuestros <a [routerLink]="['/terms-of-use']" (click)="close(true)">Términos de uso</a> y nuestra <a [routerLink]="['/privacy-policy']" (click)="close(true)">Política de privacidad</a>.</span>
</mat-dialog-content>
